import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconHeadlineStyle0 = cosmosIconCss;

const CosmosIconHeadline$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeadline extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '747dde33564b772aa28f1f1f00379d0bde679dcf', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'cec5212561a7cdae350f3c599f3f4d41166409c3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '0e239f6764c65575dba592151ff19b26d1164b93', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.55 4.007a.5.5 0 0 0-.5.5v12.986a.5.5 0 0 0 .5.5h1.952a.5.5 0 0 0 .5-.5v-5.506h4.008v5.506a.5.5 0 0 0 .5.5h1.951a.5.5 0 0 0 .5-.5V4.507a.5.5 0 0 0-.5-.5h-1.95a.5.5 0 0 0-.5.5v4.82H6v-4.82a.5.5 0 0 0-.5-.5H3.55Zm15.4 5.592a.5.5 0 0 0-.5-.5h-1.445a1 1 0 0 0-.668.256l-2.012 1.807a.5.5 0 0 0-.046.697l.472.552a.5.5 0 0 0 .69.068l.412-.325a8.41 8.41 0 0 0 .395-.375 4.14 4.14 0 0 0 .374-.415 7.473 7.473 0 0 0-.041.56l-.042.832v4.737a.5.5 0 0 0 .5.5h1.41a.5.5 0 0 0 .5-.5V9.6Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconHeadlineStyle0; }
}, [1, "cosmos-icon-headline", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-headline"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-headline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeadline$1);
            }
            break;
    } });
}

const CosmosIconHeadline = CosmosIconHeadline$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeadline, defineCustomElement };
